import { getAccessToken } from '../auth/tokenService';

const ADMIN_API_BASE = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/admin`
  : '/api/admin';

function getHeaders() {
  const token = getAccessToken();
  return {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
  };
}

/**
 * List all available processes
 */
export async function listProcesses() {
  const response = await fetch(`${ADMIN_API_BASE}/scenarios/processes`, {
    method: 'GET',
    headers: getHeaders(),
  });

  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Failed to load processes');
  }

  return response.json();
}

/**
 * List all scenarios for a process + purpose
 */
export async function listScenarios(process, purpose) {
  const response = await fetch(`${ADMIN_API_BASE}/scenarios?process=${encodeURIComponent(process)}&purpose=${encodeURIComponent(purpose)}`, {
    method: 'GET',
    headers: getHeaders(),
  });

  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Failed to load scenarios');
  }

  return response.json();
}

/**
 * Get a single scenario by ID
 */
export async function getScenario(process, purpose, scenarioId) {
  const response = await fetch(`${ADMIN_API_BASE}/scenarios/${encodeURIComponent(scenarioId)}?process=${encodeURIComponent(process)}&purpose=${encodeURIComponent(purpose)}`, {
    method: 'GET',
    headers: getHeaders(),
  });

  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Failed to load scenario');
  }

  return response.json();
}

/**
 * Create a new scenario
 */
export async function createScenario(process, purpose, body) {
  const response = await fetch(`${ADMIN_API_BASE}/scenarios?process=${encodeURIComponent(process)}&purpose=${encodeURIComponent(purpose)}`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Failed to create scenario');
  }

  return response.json();
}

/**
 * Update an existing scenario
 */
export async function updateScenario(process, purpose, scenarioId, body) {
  const response = await fetch(`${ADMIN_API_BASE}/scenarios/${encodeURIComponent(scenarioId)}?process=${encodeURIComponent(process)}&purpose=${encodeURIComponent(purpose)}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Failed to update scenario');
  }

  return response.json();
}

/**
 * Delete a scenario
 */
export async function deleteScenario(process, purpose, scenarioId) {
  const response = await fetch(`${ADMIN_API_BASE}/scenarios/${encodeURIComponent(scenarioId)}?process=${encodeURIComponent(process)}&purpose=${encodeURIComponent(purpose)}`, {
    method: 'DELETE',
    headers: getHeaders(),
  });

  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Failed to delete scenario');
  }

  return response.json();
}

/**
 * List all direct questions for a process + purpose
 */
export async function listDirectQuestions(process, purpose) {
  const response = await fetch(`${ADMIN_API_BASE}/direct-questions?process=${encodeURIComponent(process)}&purpose=${encodeURIComponent(purpose)}`, {
    method: 'GET',
    headers: getHeaders(),
  });

  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Failed to load direct questions');
  }

  return response.json();
}

/**
 * Create a new direct question
 */
export async function createDirectQuestion(process, purpose, body) {
  const response = await fetch(`${ADMIN_API_BASE}/direct-questions?process=${encodeURIComponent(process)}&purpose=${encodeURIComponent(purpose)}`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Failed to create direct question');
  }

  return response.json();
}

/**
 * Update an existing direct question
 */
export async function updateDirectQuestion(process, purpose, questionId, body) {
  const response = await fetch(`${ADMIN_API_BASE}/direct-questions/${encodeURIComponent(questionId)}?process=${encodeURIComponent(process)}&purpose=${encodeURIComponent(purpose)}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Failed to update direct question');
  }

  return response.json();
}

/**
 * Delete a direct question
 */
export async function deleteDirectQuestion(process, purpose, questionId) {
  const response = await fetch(`${ADMIN_API_BASE}/direct-questions/${encodeURIComponent(questionId)}?process=${encodeURIComponent(process)}&purpose=${encodeURIComponent(purpose)}`, {
    method: 'DELETE',
    headers: getHeaders(),
  });

  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Failed to delete direct question');
  }

  return response.json();
}
